module.exports = "/static/assets/1284ac98b48c05d0b81c1eb23532594a.png";